/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginPreviewRouteImport } from './routes/login-preview'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppPlumberManagerRouteImport } from './routes/_app.plumber-manager'
import { Route as AppNinetyRouteImport } from './routes/_app.ninety'
import { Route as AppBrainRouteImport } from './routes/_app.brain'
import { Route as AppAlertPageRouteImport } from './routes/_app.alert-page'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppNinetyIndexRouteImport } from './routes/_app.ninety.index'
import { Route as AppJobsIndexRouteImport } from './routes/_app.jobs.index'
import { Route as AppBrainIndexRouteImport } from './routes/_app.brain.index'
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index'
import { Route as AppNinetyTodosRouteImport } from './routes/_app.ninety.todos'
import { Route as AppNinetyProjectsRouteImport } from './routes/_app.ninety.projects'
import { Route as AppNinetyProcessesRouteImport } from './routes/_app.ninety.processes'
import { Route as AppNinetyKnowledgeRouteImport } from './routes/_app.ninety.knowledge'
import { Route as AppNinetyJobNotesRouteImport } from './routes/_app.ninety.job-notes'
import { Route as AppNinetyIssuesRouteImport } from './routes/_app.ninety.issues'
import { Route as AppNinetyDirectoryRouteImport } from './routes/_app.ninety.directory'
import { Route as AppNinetyCalendarRouteImport } from './routes/_app.ninety.calendar'
import { Route as AppNinetyAccountabilityRouteImport } from './routes/_app.ninety.accountability'
import { Route as AppJobsNewRouteImport } from './routes/_app.jobs.new'
import { Route as AppJobsJobNumberRouteImport } from './routes/_app.jobs.$jobNumber'
import { Route as AppDashboardsDashboardRouteImport } from './routes/_app.dashboards.$dashboard'
import { Route as AppBrainMapRouteImport } from './routes/_app.brain.map'
import { Route as AppBrainAskRouteImport } from './routes/_app.brain.ask'
import { Route as AppAdminWorkflowsRouteImport } from './routes/_app.admin.workflows'
import { Route as AppAdminVerificationRouteImport } from './routes/_app.admin.verification'
import { Route as AppAdminUsersRouteImport } from './routes/_app.admin.users'
import { Route as AppAdminTablesRouteImport } from './routes/_app.admin.tables'
import { Route as AppAdminSettingsRouteImport } from './routes/_app.admin.settings'
import { Route as AppAdminPlaybookRouteImport } from './routes/_app.admin.playbook'
import { Route as AppAdminMigrateRouteImport } from './routes/_app.admin.migrate'
import { Route as AppAdminFeedbackRouteImport } from './routes/_app.admin.feedback'
import { Route as AppAdminErrorLogRouteImport } from './routes/_app.admin.error-log'
import { Route as AppAdminDisplayTvRouteImport } from './routes/_app.admin.display-tv'
import { Route as AppAdminDataFlowRouteImport } from './routes/_app.admin.data-flow'
import { Route as AppAdminChangelogRouteImport } from './routes/_app.admin.changelog'
import { Route as AppNinetyMeetingsIndexRouteImport } from './routes/_app.ninety.meetings.index'
import { Route as AppDashboardsDashboardIndexRouteImport } from './routes/_app.dashboards.$dashboard.index'
import { Route as AppNinetyMeetingsIdRouteImport } from './routes/_app.ninety.meetings.$id'
import { Route as AppDashboardsOperationsDispatchRouteImport } from './routes/_app.dashboards.operations.dispatch'
import { Route as AppDashboardsDashboardTabRouteImport } from './routes/_app.dashboards.$dashboard.$tab'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginPreviewRoute = LoginPreviewRouteImport.update({
  id: '/login-preview',
  path: '/login-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlumberManagerRoute = AppPlumberManagerRouteImport.update({
  id: '/plumber-manager',
  path: '/plumber-manager',
  getParentRoute: () => AppRoute,
} as any)
const AppNinetyRoute = AppNinetyRouteImport.update({
  id: '/ninety',
  path: '/ninety',
  getParentRoute: () => AppRoute,
} as any)
const AppBrainRoute = AppBrainRouteImport.update({
  id: '/brain',
  path: '/brain',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertPageRoute = AppAlertPageRouteImport.update({
  id: '/alert-page',
  path: '/alert-page',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppNinetyIndexRoute = AppNinetyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AppRoute,
} as any)
const AppBrainIndexRoute = AppBrainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBrainRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppNinetyTodosRoute = AppNinetyTodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyProjectsRoute = AppNinetyProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyProcessesRoute = AppNinetyProcessesRouteImport.update({
  id: '/processes',
  path: '/processes',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyKnowledgeRoute = AppNinetyKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyJobNotesRoute = AppNinetyJobNotesRouteImport.update({
  id: '/job-notes',
  path: '/job-notes',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyIssuesRoute = AppNinetyIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyDirectoryRoute = AppNinetyDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyCalendarRoute = AppNinetyCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppNinetyAccountabilityRoute = AppNinetyAccountabilityRouteImport.update({
  id: '/accountability',
  path: '/accountability',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppJobsNewRoute = AppJobsNewRouteImport.update({
  id: '/jobs/new',
  path: '/jobs/new',
  getParentRoute: () => AppRoute,
} as any)
const AppJobsJobNumberRoute = AppJobsJobNumberRouteImport.update({
  id: '/jobs/$jobNumber',
  path: '/jobs/$jobNumber',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardsDashboardRoute = AppDashboardsDashboardRouteImport.update({
  id: '/dashboards/$dashboard',
  path: '/dashboards/$dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppBrainMapRoute = AppBrainMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppBrainRoute,
} as any)
const AppBrainAskRoute = AppBrainAskRouteImport.update({
  id: '/ask',
  path: '/ask',
  getParentRoute: () => AppBrainRoute,
} as any)
const AppAdminWorkflowsRoute = AppAdminWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminVerificationRoute = AppAdminVerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTablesRoute = AppAdminTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPlaybookRoute = AppAdminPlaybookRouteImport.update({
  id: '/playbook',
  path: '/playbook',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMigrateRoute = AppAdminMigrateRouteImport.update({
  id: '/migrate',
  path: '/migrate',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeedbackRoute = AppAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminErrorLogRoute = AppAdminErrorLogRouteImport.update({
  id: '/error-log',
  path: '/error-log',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminDisplayTvRoute = AppAdminDisplayTvRouteImport.update({
  id: '/display-tv',
  path: '/display-tv',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminDataFlowRoute = AppAdminDataFlowRouteImport.update({
  id: '/data-flow',
  path: '/data-flow',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminChangelogRoute = AppAdminChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppNinetyMeetingsIndexRoute = AppNinetyMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppDashboardsDashboardIndexRoute =
  AppDashboardsDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardsDashboardRoute,
  } as any)
const AppNinetyMeetingsIdRoute = AppNinetyMeetingsIdRouteImport.update({
  id: '/meetings/$id',
  path: '/meetings/$id',
  getParentRoute: () => AppNinetyRoute,
} as any)
const AppDashboardsOperationsDispatchRoute =
  AppDashboardsOperationsDispatchRouteImport.update({
    id: '/dashboards/operations/dispatch',
    path: '/dashboards/operations/dispatch',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardsDashboardTabRoute =
  AppDashboardsDashboardTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => AppDashboardsDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/login-preview': typeof LoginPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/alert-page': typeof AppAlertPageRoute
  '/brain': typeof AppBrainRouteWithChildren
  '/ninety': typeof AppNinetyRouteWithChildren
  '/plumber-manager': typeof AppPlumberManagerRoute
  '/admin/changelog': typeof AppAdminChangelogRoute
  '/admin/data-flow': typeof AppAdminDataFlowRoute
  '/admin/display-tv': typeof AppAdminDisplayTvRoute
  '/admin/error-log': typeof AppAdminErrorLogRoute
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/migrate': typeof AppAdminMigrateRoute
  '/admin/playbook': typeof AppAdminPlaybookRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/tables': typeof AppAdminTablesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/verification': typeof AppAdminVerificationRoute
  '/admin/workflows': typeof AppAdminWorkflowsRoute
  '/brain/ask': typeof AppBrainAskRoute
  '/brain/map': typeof AppBrainMapRoute
  '/dashboards/$dashboard': typeof AppDashboardsDashboardRouteWithChildren
  '/jobs/$jobNumber': typeof AppJobsJobNumberRoute
  '/jobs/new': typeof AppJobsNewRoute
  '/ninety/accountability': typeof AppNinetyAccountabilityRoute
  '/ninety/calendar': typeof AppNinetyCalendarRoute
  '/ninety/directory': typeof AppNinetyDirectoryRoute
  '/ninety/issues': typeof AppNinetyIssuesRoute
  '/ninety/job-notes': typeof AppNinetyJobNotesRoute
  '/ninety/knowledge': typeof AppNinetyKnowledgeRoute
  '/ninety/processes': typeof AppNinetyProcessesRoute
  '/ninety/projects': typeof AppNinetyProjectsRoute
  '/ninety/todos': typeof AppNinetyTodosRoute
  '/admin/': typeof AppAdminIndexRoute
  '/brain/': typeof AppBrainIndexRoute
  '/jobs/': typeof AppJobsIndexRoute
  '/ninety/': typeof AppNinetyIndexRoute
  '/dashboards/$dashboard/$tab': typeof AppDashboardsDashboardTabRoute
  '/dashboards/operations/dispatch': typeof AppDashboardsOperationsDispatchRoute
  '/ninety/meetings/$id': typeof AppNinetyMeetingsIdRoute
  '/dashboards/$dashboard/': typeof AppDashboardsDashboardIndexRoute
  '/ninety/meetings/': typeof AppNinetyMeetingsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/login-preview': typeof LoginPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/alert-page': typeof AppAlertPageRoute
  '/plumber-manager': typeof AppPlumberManagerRoute
  '/': typeof AppIndexRoute
  '/admin/changelog': typeof AppAdminChangelogRoute
  '/admin/data-flow': typeof AppAdminDataFlowRoute
  '/admin/display-tv': typeof AppAdminDisplayTvRoute
  '/admin/error-log': typeof AppAdminErrorLogRoute
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/migrate': typeof AppAdminMigrateRoute
  '/admin/playbook': typeof AppAdminPlaybookRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/tables': typeof AppAdminTablesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/verification': typeof AppAdminVerificationRoute
  '/admin/workflows': typeof AppAdminWorkflowsRoute
  '/brain/ask': typeof AppBrainAskRoute
  '/brain/map': typeof AppBrainMapRoute
  '/jobs/$jobNumber': typeof AppJobsJobNumberRoute
  '/jobs/new': typeof AppJobsNewRoute
  '/ninety/accountability': typeof AppNinetyAccountabilityRoute
  '/ninety/calendar': typeof AppNinetyCalendarRoute
  '/ninety/directory': typeof AppNinetyDirectoryRoute
  '/ninety/issues': typeof AppNinetyIssuesRoute
  '/ninety/job-notes': typeof AppNinetyJobNotesRoute
  '/ninety/knowledge': typeof AppNinetyKnowledgeRoute
  '/ninety/processes': typeof AppNinetyProcessesRoute
  '/ninety/projects': typeof AppNinetyProjectsRoute
  '/ninety/todos': typeof AppNinetyTodosRoute
  '/admin': typeof AppAdminIndexRoute
  '/brain': typeof AppBrainIndexRoute
  '/jobs': typeof AppJobsIndexRoute
  '/ninety': typeof AppNinetyIndexRoute
  '/dashboards/$dashboard/$tab': typeof AppDashboardsDashboardTabRoute
  '/dashboards/operations/dispatch': typeof AppDashboardsOperationsDispatchRoute
  '/ninety/meetings/$id': typeof AppNinetyMeetingsIdRoute
  '/dashboards/$dashboard': typeof AppDashboardsDashboardIndexRoute
  '/ninety/meetings': typeof AppNinetyMeetingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/login-preview': typeof LoginPreviewRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/alert-page': typeof AppAlertPageRoute
  '/_app/brain': typeof AppBrainRouteWithChildren
  '/_app/ninety': typeof AppNinetyRouteWithChildren
  '/_app/plumber-manager': typeof AppPlumberManagerRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/changelog': typeof AppAdminChangelogRoute
  '/_app/admin/data-flow': typeof AppAdminDataFlowRoute
  '/_app/admin/display-tv': typeof AppAdminDisplayTvRoute
  '/_app/admin/error-log': typeof AppAdminErrorLogRoute
  '/_app/admin/feedback': typeof AppAdminFeedbackRoute
  '/_app/admin/migrate': typeof AppAdminMigrateRoute
  '/_app/admin/playbook': typeof AppAdminPlaybookRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/tables': typeof AppAdminTablesRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/admin/verification': typeof AppAdminVerificationRoute
  '/_app/admin/workflows': typeof AppAdminWorkflowsRoute
  '/_app/brain/ask': typeof AppBrainAskRoute
  '/_app/brain/map': typeof AppBrainMapRoute
  '/_app/dashboards/$dashboard': typeof AppDashboardsDashboardRouteWithChildren
  '/_app/jobs/$jobNumber': typeof AppJobsJobNumberRoute
  '/_app/jobs/new': typeof AppJobsNewRoute
  '/_app/ninety/accountability': typeof AppNinetyAccountabilityRoute
  '/_app/ninety/calendar': typeof AppNinetyCalendarRoute
  '/_app/ninety/directory': typeof AppNinetyDirectoryRoute
  '/_app/ninety/issues': typeof AppNinetyIssuesRoute
  '/_app/ninety/job-notes': typeof AppNinetyJobNotesRoute
  '/_app/ninety/knowledge': typeof AppNinetyKnowledgeRoute
  '/_app/ninety/processes': typeof AppNinetyProcessesRoute
  '/_app/ninety/projects': typeof AppNinetyProjectsRoute
  '/_app/ninety/todos': typeof AppNinetyTodosRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/brain/': typeof AppBrainIndexRoute
  '/_app/jobs/': typeof AppJobsIndexRoute
  '/_app/ninety/': typeof AppNinetyIndexRoute
  '/_app/dashboards/$dashboard/$tab': typeof AppDashboardsDashboardTabRoute
  '/_app/dashboards/operations/dispatch': typeof AppDashboardsOperationsDispatchRoute
  '/_app/ninety/meetings/$id': typeof AppNinetyMeetingsIdRoute
  '/_app/dashboards/$dashboard/': typeof AppDashboardsDashboardIndexRoute
  '/_app/ninety/meetings/': typeof AppNinetyMeetingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/login-preview'
    | '/reset-password'
    | '/admin'
    | '/alert-page'
    | '/brain'
    | '/ninety'
    | '/plumber-manager'
    | '/admin/changelog'
    | '/admin/data-flow'
    | '/admin/display-tv'
    | '/admin/error-log'
    | '/admin/feedback'
    | '/admin/migrate'
    | '/admin/playbook'
    | '/admin/settings'
    | '/admin/tables'
    | '/admin/users'
    | '/admin/verification'
    | '/admin/workflows'
    | '/brain/ask'
    | '/brain/map'
    | '/dashboards/$dashboard'
    | '/jobs/$jobNumber'
    | '/jobs/new'
    | '/ninety/accountability'
    | '/ninety/calendar'
    | '/ninety/directory'
    | '/ninety/issues'
    | '/ninety/job-notes'
    | '/ninety/knowledge'
    | '/ninety/processes'
    | '/ninety/projects'
    | '/ninety/todos'
    | '/admin/'
    | '/brain/'
    | '/jobs/'
    | '/ninety/'
    | '/dashboards/$dashboard/$tab'
    | '/dashboards/operations/dispatch'
    | '/ninety/meetings/$id'
    | '/dashboards/$dashboard/'
    | '/ninety/meetings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/login-preview'
    | '/reset-password'
    | '/alert-page'
    | '/plumber-manager'
    | '/'
    | '/admin/changelog'
    | '/admin/data-flow'
    | '/admin/display-tv'
    | '/admin/error-log'
    | '/admin/feedback'
    | '/admin/migrate'
    | '/admin/playbook'
    | '/admin/settings'
    | '/admin/tables'
    | '/admin/users'
    | '/admin/verification'
    | '/admin/workflows'
    | '/brain/ask'
    | '/brain/map'
    | '/jobs/$jobNumber'
    | '/jobs/new'
    | '/ninety/accountability'
    | '/ninety/calendar'
    | '/ninety/directory'
    | '/ninety/issues'
    | '/ninety/job-notes'
    | '/ninety/knowledge'
    | '/ninety/processes'
    | '/ninety/projects'
    | '/ninety/todos'
    | '/admin'
    | '/brain'
    | '/jobs'
    | '/ninety'
    | '/dashboards/$dashboard/$tab'
    | '/dashboards/operations/dispatch'
    | '/ninety/meetings/$id'
    | '/dashboards/$dashboard'
    | '/ninety/meetings'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/login-preview'
    | '/reset-password'
    | '/_app/admin'
    | '/_app/alert-page'
    | '/_app/brain'
    | '/_app/ninety'
    | '/_app/plumber-manager'
    | '/_app/'
    | '/_app/admin/changelog'
    | '/_app/admin/data-flow'
    | '/_app/admin/display-tv'
    | '/_app/admin/error-log'
    | '/_app/admin/feedback'
    | '/_app/admin/migrate'
    | '/_app/admin/playbook'
    | '/_app/admin/settings'
    | '/_app/admin/tables'
    | '/_app/admin/users'
    | '/_app/admin/verification'
    | '/_app/admin/workflows'
    | '/_app/brain/ask'
    | '/_app/brain/map'
    | '/_app/dashboards/$dashboard'
    | '/_app/jobs/$jobNumber'
    | '/_app/jobs/new'
    | '/_app/ninety/accountability'
    | '/_app/ninety/calendar'
    | '/_app/ninety/directory'
    | '/_app/ninety/issues'
    | '/_app/ninety/job-notes'
    | '/_app/ninety/knowledge'
    | '/_app/ninety/processes'
    | '/_app/ninety/projects'
    | '/_app/ninety/todos'
    | '/_app/admin/'
    | '/_app/brain/'
    | '/_app/jobs/'
    | '/_app/ninety/'
    | '/_app/dashboards/$dashboard/$tab'
    | '/_app/dashboards/operations/dispatch'
    | '/_app/ninety/meetings/$id'
    | '/_app/dashboards/$dashboard/'
    | '/_app/ninety/meetings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginPreviewRoute: typeof LoginPreviewRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-preview': {
      id: '/login-preview'
      path: '/login-preview'
      fullPath: '/login-preview'
      preLoaderRoute: typeof LoginPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/plumber-manager': {
      id: '/_app/plumber-manager'
      path: '/plumber-manager'
      fullPath: '/plumber-manager'
      preLoaderRoute: typeof AppPlumberManagerRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ninety': {
      id: '/_app/ninety'
      path: '/ninety'
      fullPath: '/ninety'
      preLoaderRoute: typeof AppNinetyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brain': {
      id: '/_app/brain'
      path: '/brain'
      fullPath: '/brain'
      preLoaderRoute: typeof AppBrainRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alert-page': {
      id: '/_app/alert-page'
      path: '/alert-page'
      fullPath: '/alert-page'
      preLoaderRoute: typeof AppAlertPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ninety/': {
      id: '/_app/ninety/'
      path: '/'
      fullPath: '/ninety/'
      preLoaderRoute: typeof AppNinetyIndexRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/jobs/': {
      id: '/_app/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AppJobsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brain/': {
      id: '/_app/brain/'
      path: '/'
      fullPath: '/brain/'
      preLoaderRoute: typeof AppBrainIndexRouteImport
      parentRoute: typeof AppBrainRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/ninety/todos': {
      id: '/_app/ninety/todos'
      path: '/todos'
      fullPath: '/ninety/todos'
      preLoaderRoute: typeof AppNinetyTodosRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/projects': {
      id: '/_app/ninety/projects'
      path: '/projects'
      fullPath: '/ninety/projects'
      preLoaderRoute: typeof AppNinetyProjectsRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/processes': {
      id: '/_app/ninety/processes'
      path: '/processes'
      fullPath: '/ninety/processes'
      preLoaderRoute: typeof AppNinetyProcessesRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/knowledge': {
      id: '/_app/ninety/knowledge'
      path: '/knowledge'
      fullPath: '/ninety/knowledge'
      preLoaderRoute: typeof AppNinetyKnowledgeRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/job-notes': {
      id: '/_app/ninety/job-notes'
      path: '/job-notes'
      fullPath: '/ninety/job-notes'
      preLoaderRoute: typeof AppNinetyJobNotesRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/issues': {
      id: '/_app/ninety/issues'
      path: '/issues'
      fullPath: '/ninety/issues'
      preLoaderRoute: typeof AppNinetyIssuesRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/directory': {
      id: '/_app/ninety/directory'
      path: '/directory'
      fullPath: '/ninety/directory'
      preLoaderRoute: typeof AppNinetyDirectoryRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/calendar': {
      id: '/_app/ninety/calendar'
      path: '/calendar'
      fullPath: '/ninety/calendar'
      preLoaderRoute: typeof AppNinetyCalendarRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/ninety/accountability': {
      id: '/_app/ninety/accountability'
      path: '/accountability'
      fullPath: '/ninety/accountability'
      preLoaderRoute: typeof AppNinetyAccountabilityRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/jobs/new': {
      id: '/_app/jobs/new'
      path: '/jobs/new'
      fullPath: '/jobs/new'
      preLoaderRoute: typeof AppJobsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/jobs/$jobNumber': {
      id: '/_app/jobs/$jobNumber'
      path: '/jobs/$jobNumber'
      fullPath: '/jobs/$jobNumber'
      preLoaderRoute: typeof AppJobsJobNumberRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboard': {
      id: '/_app/dashboards/$dashboard'
      path: '/dashboards/$dashboard'
      fullPath: '/dashboards/$dashboard'
      preLoaderRoute: typeof AppDashboardsDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brain/map': {
      id: '/_app/brain/map'
      path: '/map'
      fullPath: '/brain/map'
      preLoaderRoute: typeof AppBrainMapRouteImport
      parentRoute: typeof AppBrainRoute
    }
    '/_app/brain/ask': {
      id: '/_app/brain/ask'
      path: '/ask'
      fullPath: '/brain/ask'
      preLoaderRoute: typeof AppBrainAskRouteImport
      parentRoute: typeof AppBrainRoute
    }
    '/_app/admin/workflows': {
      id: '/_app/admin/workflows'
      path: '/workflows'
      fullPath: '/admin/workflows'
      preLoaderRoute: typeof AppAdminWorkflowsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/verification': {
      id: '/_app/admin/verification'
      path: '/verification'
      fullPath: '/admin/verification'
      preLoaderRoute: typeof AppAdminVerificationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/tables': {
      id: '/_app/admin/tables'
      path: '/tables'
      fullPath: '/admin/tables'
      preLoaderRoute: typeof AppAdminTablesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/playbook': {
      id: '/_app/admin/playbook'
      path: '/playbook'
      fullPath: '/admin/playbook'
      preLoaderRoute: typeof AppAdminPlaybookRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/migrate': {
      id: '/_app/admin/migrate'
      path: '/migrate'
      fullPath: '/admin/migrate'
      preLoaderRoute: typeof AppAdminMigrateRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feedback': {
      id: '/_app/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AppAdminFeedbackRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/error-log': {
      id: '/_app/admin/error-log'
      path: '/error-log'
      fullPath: '/admin/error-log'
      preLoaderRoute: typeof AppAdminErrorLogRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/display-tv': {
      id: '/_app/admin/display-tv'
      path: '/display-tv'
      fullPath: '/admin/display-tv'
      preLoaderRoute: typeof AppAdminDisplayTvRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/data-flow': {
      id: '/_app/admin/data-flow'
      path: '/data-flow'
      fullPath: '/admin/data-flow'
      preLoaderRoute: typeof AppAdminDataFlowRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/changelog': {
      id: '/_app/admin/changelog'
      path: '/changelog'
      fullPath: '/admin/changelog'
      preLoaderRoute: typeof AppAdminChangelogRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/ninety/meetings/': {
      id: '/_app/ninety/meetings/'
      path: '/meetings'
      fullPath: '/ninety/meetings/'
      preLoaderRoute: typeof AppNinetyMeetingsIndexRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/dashboards/$dashboard/': {
      id: '/_app/dashboards/$dashboard/'
      path: '/'
      fullPath: '/dashboards/$dashboard/'
      preLoaderRoute: typeof AppDashboardsDashboardIndexRouteImport
      parentRoute: typeof AppDashboardsDashboardRoute
    }
    '/_app/ninety/meetings/$id': {
      id: '/_app/ninety/meetings/$id'
      path: '/meetings/$id'
      fullPath: '/ninety/meetings/$id'
      preLoaderRoute: typeof AppNinetyMeetingsIdRouteImport
      parentRoute: typeof AppNinetyRoute
    }
    '/_app/dashboards/operations/dispatch': {
      id: '/_app/dashboards/operations/dispatch'
      path: '/dashboards/operations/dispatch'
      fullPath: '/dashboards/operations/dispatch'
      preLoaderRoute: typeof AppDashboardsOperationsDispatchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboards/$dashboard/$tab': {
      id: '/_app/dashboards/$dashboard/$tab'
      path: '/$tab'
      fullPath: '/dashboards/$dashboard/$tab'
      preLoaderRoute: typeof AppDashboardsDashboardTabRouteImport
      parentRoute: typeof AppDashboardsDashboardRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminChangelogRoute: typeof AppAdminChangelogRoute
  AppAdminDataFlowRoute: typeof AppAdminDataFlowRoute
  AppAdminDisplayTvRoute: typeof AppAdminDisplayTvRoute
  AppAdminErrorLogRoute: typeof AppAdminErrorLogRoute
  AppAdminFeedbackRoute: typeof AppAdminFeedbackRoute
  AppAdminMigrateRoute: typeof AppAdminMigrateRoute
  AppAdminPlaybookRoute: typeof AppAdminPlaybookRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminTablesRoute: typeof AppAdminTablesRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminVerificationRoute: typeof AppAdminVerificationRoute
  AppAdminWorkflowsRoute: typeof AppAdminWorkflowsRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminChangelogRoute: AppAdminChangelogRoute,
  AppAdminDataFlowRoute: AppAdminDataFlowRoute,
  AppAdminDisplayTvRoute: AppAdminDisplayTvRoute,
  AppAdminErrorLogRoute: AppAdminErrorLogRoute,
  AppAdminFeedbackRoute: AppAdminFeedbackRoute,
  AppAdminMigrateRoute: AppAdminMigrateRoute,
  AppAdminPlaybookRoute: AppAdminPlaybookRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminTablesRoute: AppAdminTablesRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminVerificationRoute: AppAdminVerificationRoute,
  AppAdminWorkflowsRoute: AppAdminWorkflowsRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppBrainRouteChildren {
  AppBrainAskRoute: typeof AppBrainAskRoute
  AppBrainMapRoute: typeof AppBrainMapRoute
  AppBrainIndexRoute: typeof AppBrainIndexRoute
}

const AppBrainRouteChildren: AppBrainRouteChildren = {
  AppBrainAskRoute: AppBrainAskRoute,
  AppBrainMapRoute: AppBrainMapRoute,
  AppBrainIndexRoute: AppBrainIndexRoute,
}

const AppBrainRouteWithChildren = AppBrainRoute._addFileChildren(
  AppBrainRouteChildren,
)

interface AppNinetyRouteChildren {
  AppNinetyAccountabilityRoute: typeof AppNinetyAccountabilityRoute
  AppNinetyCalendarRoute: typeof AppNinetyCalendarRoute
  AppNinetyDirectoryRoute: typeof AppNinetyDirectoryRoute
  AppNinetyIssuesRoute: typeof AppNinetyIssuesRoute
  AppNinetyJobNotesRoute: typeof AppNinetyJobNotesRoute
  AppNinetyKnowledgeRoute: typeof AppNinetyKnowledgeRoute
  AppNinetyProcessesRoute: typeof AppNinetyProcessesRoute
  AppNinetyProjectsRoute: typeof AppNinetyProjectsRoute
  AppNinetyTodosRoute: typeof AppNinetyTodosRoute
  AppNinetyIndexRoute: typeof AppNinetyIndexRoute
  AppNinetyMeetingsIdRoute: typeof AppNinetyMeetingsIdRoute
  AppNinetyMeetingsIndexRoute: typeof AppNinetyMeetingsIndexRoute
}

const AppNinetyRouteChildren: AppNinetyRouteChildren = {
  AppNinetyAccountabilityRoute: AppNinetyAccountabilityRoute,
  AppNinetyCalendarRoute: AppNinetyCalendarRoute,
  AppNinetyDirectoryRoute: AppNinetyDirectoryRoute,
  AppNinetyIssuesRoute: AppNinetyIssuesRoute,
  AppNinetyJobNotesRoute: AppNinetyJobNotesRoute,
  AppNinetyKnowledgeRoute: AppNinetyKnowledgeRoute,
  AppNinetyProcessesRoute: AppNinetyProcessesRoute,
  AppNinetyProjectsRoute: AppNinetyProjectsRoute,
  AppNinetyTodosRoute: AppNinetyTodosRoute,
  AppNinetyIndexRoute: AppNinetyIndexRoute,
  AppNinetyMeetingsIdRoute: AppNinetyMeetingsIdRoute,
  AppNinetyMeetingsIndexRoute: AppNinetyMeetingsIndexRoute,
}

const AppNinetyRouteWithChildren = AppNinetyRoute._addFileChildren(
  AppNinetyRouteChildren,
)

interface AppDashboardsDashboardRouteChildren {
  AppDashboardsDashboardTabRoute: typeof AppDashboardsDashboardTabRoute
  AppDashboardsDashboardIndexRoute: typeof AppDashboardsDashboardIndexRoute
}

const AppDashboardsDashboardRouteChildren: AppDashboardsDashboardRouteChildren =
  {
    AppDashboardsDashboardTabRoute: AppDashboardsDashboardTabRoute,
    AppDashboardsDashboardIndexRoute: AppDashboardsDashboardIndexRoute,
  }

const AppDashboardsDashboardRouteWithChildren =
  AppDashboardsDashboardRoute._addFileChildren(
    AppDashboardsDashboardRouteChildren,
  )

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAlertPageRoute: typeof AppAlertPageRoute
  AppBrainRoute: typeof AppBrainRouteWithChildren
  AppNinetyRoute: typeof AppNinetyRouteWithChildren
  AppPlumberManagerRoute: typeof AppPlumberManagerRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDashboardsDashboardRoute: typeof AppDashboardsDashboardRouteWithChildren
  AppJobsJobNumberRoute: typeof AppJobsJobNumberRoute
  AppJobsNewRoute: typeof AppJobsNewRoute
  AppJobsIndexRoute: typeof AppJobsIndexRoute
  AppDashboardsOperationsDispatchRoute: typeof AppDashboardsOperationsDispatchRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAlertPageRoute: AppAlertPageRoute,
  AppBrainRoute: AppBrainRouteWithChildren,
  AppNinetyRoute: AppNinetyRouteWithChildren,
  AppPlumberManagerRoute: AppPlumberManagerRoute,
  AppIndexRoute: AppIndexRoute,
  AppDashboardsDashboardRoute: AppDashboardsDashboardRouteWithChildren,
  AppJobsJobNumberRoute: AppJobsJobNumberRoute,
  AppJobsNewRoute: AppJobsNewRoute,
  AppJobsIndexRoute: AppJobsIndexRoute,
  AppDashboardsOperationsDispatchRoute: AppDashboardsOperationsDispatchRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginPreviewRoute: LoginPreviewRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
